import { ReactElement, ReactNode } from 'react';
import ChevronLeft15 from '../svg/ChevronLeft15.svg';
import { OptionalLink } from 'components/common/OptionalLink';
import styles from './MyAccountLink.module.css';

interface Props {
  href?: string;
  onClick?: () => void;
  children: ReactNode;
  imageElement: ReactElement;
  badgeText?: string;
}

const MyAccountLink = (props: Props) => {
  return (
    <OptionalLink
      href={props.href}
      onClick={props.onClick}
      className={styles.container}
    >
      {props.imageElement}
      <div className={styles.children}>
        {props.children}
        {props.badgeText && (
          <span className={'aboutUsTypographyCaption ' + styles.badge}>
            {props.badgeText}
          </span>
        )}
      </div>
      <ChevronLeft15 className={styles.chevron} />
    </OptionalLink>
  );
};

export default MyAccountLink;
